export function objectToURLParams(obj: any) {
  const queryParams = new URLSearchParams();
  for (const key in obj) {
    queryParams.append(key, obj[key]);
  }
  return queryParams.toString();
}

/** Frontend uses camel case for inputs and params, backend uses snake case. */
export const camelToSnakeCase = (str: string) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

/** Backend response casing to frontend casing */
export const snakeToCamelCase = (str: string) =>
  str
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace("-", "").replace("_", "")
    );
export const convertObjectToCamelCase = <
  T extends Record<string, unknown> | any[]
>(
  obj: T
): T => {
  if (Array.isArray(obj)) {
    return obj.map((item) => {
      if (typeof item === "object" && item !== null) {
        return convertObjectToCamelCase(item);
      }
      return item;
    }) as T;
  } else {
    const newObj: any = {};

    for (const key in obj) {
      const camelCaseKey = snakeToCamelCase(key) as keyof typeof obj;

      if (
        typeof obj[key] === "object" &&
        obj[key] !== null &&
        !(obj[key] instanceof Date)
      ) {
        newObj[camelCaseKey] = convertObjectToCamelCase(obj[key] as T);
      } else {
        newObj[camelCaseKey] = obj[key];
      }
    }

    return newObj as T;
  }
};
export const convertObjectToSnakeCase = <
  T extends Record<string, unknown> | any[]
>(
  obj: T
): T => {
  // Convert camelCase string to snake_case
  const camelToSnakeCase = (str: string) => {
    return str.replace(/([A-Z])/g, "_$1").toLowerCase();
  };

  if (Array.isArray(obj)) {
    return obj.map((item) => {
      if (typeof item === "object" && item !== null) {
        return convertObjectToSnakeCase(item);
      }
      return item;
    }) as T;
  } else {
    const newObj: any = {};

    for (const key in obj) {
      const snakeCaseKey = camelToSnakeCase(key) as keyof typeof obj;

      if (
        typeof obj[key] === "object" &&
        obj[key] !== null &&
        !(obj[key] instanceof Date)
      ) {
        newObj[snakeCaseKey] = convertObjectToSnakeCase(obj[key] as T);
      } else {
        newObj[snakeCaseKey] = obj[key];
      }
    }

    return newObj as T;
  }
};
